export default __webpack_public_path__ + "static/media/add_user.44ef792f.svg";